import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Image } from "semantic-ui-react";

function ResultRenderer({ results }) {
  return (
    <Container>
      <Row>
        <Col lg={8}>
          <h6>{`${results.user?.firstName || results.firstName} ${
            results.user?.lastName || results.lastName
          }`}</h6>
          <Row>
            <Col>
              <p style={{ fontSize: 12, color: "grey" }}>
                {results.user
                  ? results.user?.role
                    ? results.user?.role
                    : "N/A"
                  : `Level ${results.level}`}
              </p>
            </Col>
          </Row>
        </Col>
        <Col>
          <Image src={`${results.user?.image || results.image}`} />
        </Col>
      </Row>
    </Container>
  );
}

export default ResultRenderer;
